import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { BACKEND_BASE_URL, TABLET_BREAKPOINT } from '../../Constants/constant';
import { useApplicationContext } from '../../Context/applicationContext';
import KenStepperFooter from '../KenApplicationForm/Components/KenStepperFooter';
import ThankYouPage from '../KenApplicationForm/Components/ThankYouPage';
import KenSummaryStep from '../KenSummaryPage';
import { useNavigate } from 'react-router-dom';
import * as _ from 'lodash';
import FormStep from './Form';
import KenButton from '../KenButton';
import KenInput from '../KenInput';
import Divider from '@mui/material/Divider';
import { useAppContext } from '../../Context/appContext';
import DocumentUpload from './documentUpload';
import { createUpdateApplication, postInitatePayment, deleteRecordData } from '../../Utils/apiServices';
import KenLoader from '../KenLoader';
import converter from 'number-to-words';
import Declaration from '../KenApplicationForm/Components/DeclarationPage';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form';
import { addExtrasFieldsToObject, applicationAddCurrentStep, filterDirtyFields, getDirtyValues } from '../../Utils/Helpers/applicationHelper';


// Any special cases like payments,summary based on the stepType will be handled
// NOTE: These special steps should be coupled with any other steps

const useStyles = makeStyles((theme) => ({
  thankYouContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      width: '80%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
  title: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'font-style': 'normal',
      'font-weight': '500',
      'font-size': '20px',
      'line-height': '23px',
      color: '#000000',
    },
  },
  subTitle: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'font-style': 'normal',
      'font-weight': '400',
      'font-size': '16px',
      'line-height': '150%',
      'text-align': 'center',
      color: '#505F79',
    },
  },
  link: {
    color: '#0000EE',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  Heading: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#092682',
  },
  SubHeading: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#7A869A',
    textTransform: 'capitalize',
  },
  SubHeading2: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: '13px',
    color: '#061938',
  },
}));

export default function Stepper({ step }) {
  const { applicationState, applicationDispatch } = useApplicationContext();
  const formRef = useRef();
  const { applicationData, applicationId, activeStep, applicantId, totalSteps, form } = applicationState;

  const { dispatch: dispatchAppContext } = useAppContext();

  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const isLastStep = totalSteps - 1 === activeStep;

  const methods = useForm({
    defaultValues: applicationData,
    mode: 'all',
    reValidateMode: 'onChange',
  });

  const {
    formState: { errors, dirtyFields },
    getValues,
    reset,
  } = methods;

  // Reset form
  const resetForm = (data = applicationData) => {
    reset(data, {
      keepDirty: false,
      keepErrors: false,
      keepDirtyValues: false,
      keepTouched: false,
      keepValues: false,
    });
  };

  useEffect(() => {
    resetForm();
    window.scrollTo(0, 0);
  }, [activeStep]);

  const handlePay = () => {
    setLoader(true);
    let applicantName = `${applicationState?.applicationData?.applicant?.firstName} ${applicationState?.applicationData?.applicant?.lastName}`;
    let appfee = Math.round(applicationState?.feeDetails?.amount || 0);
    const payload = {
      amount: appfee * 100,
      currency: 'INR',
      accept_partial: false,
      description: applicationState.form?.formName,
      customer: {
        name: applicantName,
        email: applicationState?.applicationData?.applicant?.email,
        applicationId: applicationState?.applicationId,
      },
      notify: {
        sms: true,
        email: true,
      },
      reminder_enable: true,
      notes: {
        policy_name: window.location.href,
      },
      callback_url: `${BACKEND_BASE_URL}callback`,
      callback_method: 'get',
    };
    postInitatePayment(payload)
      .then((res) => {
        if (res?.id) {
          setLoader(false);
          window.location.href = res?.short_url;
        }
      })
      .catch((error) => {
        const errorMessage = error && error?.response?.data ? (Array.isArray(error?.response?.data?.errorMessages) ? error?.response?.data?.errorMessages[0]?.errorMessage : error?.response?.data?.errorMessage) : 'Something went wrong';
        enqueueSnackbar(errorMessage, {
          variant: 'error',
        });
        setLoader(false);
      });
  };

  // Next handler
  const handleNext = () => {
    if (!_.isEmpty(errors)) {
      enqueueSnackbar(t('messages:Application_Errors_Found'), {
        variant: 'info',
      });
      return;
    }


    console.log('activeStep', isLastStep, applicationState, activeStep);
    if (isLastStep && applicationState?.summaryEdit === '') {
      if (applicationState?.declaration) {
        let data = applicationState?.applicationData?.application;
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString();
        data.currentStep = parseInt(applicationState?.totalSteps) - 1;
        data.applicationStatus = 'Submitted';
        data.applicationDate = formattedDate;
        dispatchAppContext({ type: 'udpateLoading', value: true });
        createUpdateApplication({
          applicationId: applicationState?.applicationId,
          application: { ...data },
        })
          .then((res) => {
            if (res?.success) {
              applicationDispatch({
                type: 'update',
                payload: { applicationData: res.data },
              });
              applicationDispatch({ type: 'nextStep' });
              applicationDispatch({ type: 'applicationSubmitted' });
            }
            dispatchAppContext({ type: 'udpateLoading', value: false });
          })
          .catch((err) => {
            dispatchAppContext({ type: 'udpateLoading', value: false });
            console.log('Updating data failed. Try again');
          });
        return;
      } else {
        return enqueueSnackbar('Please check the declaration box', {
          variant: 'error',
        });
      }
    } else if (isLastStep && applicationState?.summaryEdit !== '') {
      let changedValues = getDirtyValues(filterDirtyFields(dirtyFields), getValues());


      // if no dirtyValues show alert no changes found
      if (_.isEmpty(changedValues) && !applicationState) {
        enqueueSnackbar(t('messages:Application_No_Changes'), {
          variant: 'info',
        });
        return;
      }


      if (changedValues?.application?.stream) {
        if (Array.isArray(changedValues.application.stream)) {
          let customToolValue;
          const specialAbility = changedValues.application.stream || [];
          specialAbility.forEach((items, index) => {
            if (index === 0) {
              customToolValue = `${items};`;
            } else if (index < specialAbility.length - 1) {
              customToolValue = customToolValue + `${items};`;
            } else {
              customToolValue = customToolValue + items;
            }
          });
          changedValues['application']['stream'] = customToolValue;
        }
      }


      const payload = addExtrasFieldsToObject(changedValues, {
        applicationId,
        applicantId,
        parentId: applicantId,
      });




    if(payload?.applicant?.guardian == "No") {
      if(applicationData?.applicantRelations?.length > 0) {
        deleteRecordData(`type=applicantRelations&recordIds=${applicationData?.applicantRelations[2]?.recordId}`)
      }
    }
       
      dispatchAppContext({ type: 'udpateLoading', value: true });
      createUpdateApplication({ applicationId, ...payload })
        .then((res) => {
          if (res?.success) {
            dispatchAppContext({ type: 'udpateLoading', value: false });
            enqueueSnackbar(t('messages:Application_Save_Success'), {
              variant: 'success',
            });
            applicationDispatch({
              type: 'update',
              payload: { applicationData: res.data },
            });
          }
          applicationDispatch({
            type: 'updateSummary',
            payload: {
              ...applicationState,
              summaryEdit: '',
            },
          });
        })
        .catch((error) => {
          dispatchAppContext({ type: 'udpateLoading', value: false });
          const errorMessage = error && error?.response?.data ? (Array.isArray(error?.response?.data?.errorMessages) ? error?.response?.data?.errorMessages[0]?.errorMessage : error?.response?.data?.errorMessage) : 'Something went wrong';
          enqueueSnackbar(errorMessage, {
            variant: 'error',
          });
        });
    }


    if (applicationState?.steps[activeStep]?.stepId === 'declaration') {
      if (applicationState.admissionInitiatedBy === null) {
        return enqueueSnackbar('Please select the admission initiator', {
          variant: 'error',
        });
      }
      if (!applicationState.formalDeclaration) {
        return enqueueSnackbar('Please check the declaration box', {
          variant: 'error',
        });
      }
      let data = applicationState?.applicationData?.application;
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString();
      data.currentStep = applicationState?.activeStep >= parseInt(applicationData?.application?.currentStep) ? parseInt(applicationData?.application?.currentStep) + 1 : parseInt(applicationData?.application?.currentStep);
      data.applicationDate = formattedDate;
      data['admissionProcessIsInitiatedBy'] = applicationState.admissionInitiatedBy;
      data['iAgree'] = applicationState.formalDeclaration;
      dispatchAppContext({ type: 'udpateLoading', value: true });
      createUpdateApplication({
        applicationId: applicationState?.applicationId,
        application: { ...data },
      })
        .then((res) => {
          if (res?.success) {
            applicationDispatch({
              type: 'update',
              payload: { applicationData: res.data },
            });
            applicationDispatch({ type: 'nextStep' });
          }
          dispatchAppContext({ type: 'udpateLoading', value: false });
        })
        .catch((err) => {
          dispatchAppContext({ type: 'udpateLoading', value: false });
          console.log('Updating data failed. Try again');
        });
      return;
    }


    if (applicationState?.steps[activeStep]?.stepId === 'payment' && applicationData?.application?.applicationStatus === 'Incomplete') {
      handlePay();
      return;
    }


    if (applicationState?.steps[activeStep]?.stepId === 'Upload Documents') {
      const requiredDocuments = applicationState?.documents?.filter((items) => {
        return items?.documentRequirement === 'Mandatory';
      });
      const submittedDocuments = applicationState?.documents?.filter((items) => {
        return items?.documentRequirement === 'Mandatory' && items?.fileName !== null;
      });
      if (requiredDocuments.length !== submittedDocuments.length) {
        return enqueueSnackbar('Please upload all mandatory Documents', {
          variant: 'info',
        });
      }
    }
    if (applicationState?.summaryEdit === '') {
      formRef?.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  };


  const handlePrev = () => {
    applicationDispatch({ type: 'prevStep' });
  };


  const handleSave = () => {
    let changedValues = getDirtyValues(filterDirtyFields(dirtyFields), getValues());


    // if no dirtyValues show alert no changes found
    if (_.isEmpty(changedValues) && !applicationState) {
      enqueueSnackbar(t('messages:Application_No_Changes'), {
        variant: 'info',
      });
      return;
    }
    if (changedValues?.application?.stream) {
      if (Array.isArray(changedValues.application.stream)) {
        let customToolValue;
        const specialAbility = changedValues.application.stream || [];
        specialAbility.forEach((items, index) => {
          if (index === 0) {
            customToolValue = `${items};`;
          } else if (index < specialAbility.length - 1) {
            customToolValue = customToolValue + `${items};`;
          } else {
            customToolValue = customToolValue + items;
          }
        });
        changedValues['application']['stream'] = customToolValue;
      }
    }


    const payload = addExtrasFieldsToObject(changedValues, {
      applicationId,
      applicantId,
      parentId: applicantId,
    });


    dispatchAppContext({ type: 'udpateLoading', value: true });
    createUpdateApplication({ applicationId, ...payload })
      .then((res) => {
        if (res?.success) {
          dispatchAppContext({ type: 'udpateLoading', value: false });
          enqueueSnackbar(t('messages:Application_Save_Success'), {
            variant: 'success',
          });
          applicationDispatch({
            type: 'update',
            payload: { applicationData: res.data },
          });
          resetForm(res.data);
        }
      })
      .catch((error) => {
        dispatchAppContext({ type: 'udpateLoading', value: false });
        const errorMessage = error && error?.response?.data ? (Array.isArray(error?.response?.data?.errorMessages) ? error?.response?.data?.errorMessages[0]?.errorMessage : error?.response?.data?.errorMessage) : 'Something went wrong';
        enqueueSnackbar(errorMessage, {
          variant: 'error',
        });
      });
  };


  const onSubmit = (formValues) => {
    let changedValues = getDirtyValues(filterDirtyFields(dirtyFields), getValues());


    // For program selection validation
    // if ((activeStep === 0 || activeStep === form.totalSteps) && changedValues.application) {
    //   const branchDatas = applicationState.formOptions[changedValues.application.appliedProgram];
    //   const hasData = (branchDatas || []).filter((items) => {
    //     return items?.value === changedValues.application.programId;
    //   });
    //   if (hasData.length === 0) {
    //     return enqueueSnackbar('Please select a class', { variant: 'error' });
    //   }
    // }


    if (_.isEmpty(changedValues) && !applicationState) {
      applicationDispatch({ type: 'nextStep' });
      // enqueueSnackbar(t('messages:Application_No_Changes'), {
      //   variant: 'info',
      // });
      return;
    }


    if (changedValues?.application?.stream) {
      if (Array.isArray(changedValues.application.stream)) {
        let customToolValue;
        const specialAbility = changedValues.application.stream || [];
        specialAbility.forEach((items, index) => {
          if (index === 0) {
            customToolValue = `${items};`;
          } else if (index < specialAbility.length - 1) {
            customToolValue = customToolValue + `${items};`;
          } else {
            customToolValue = customToolValue + items;
          }
        });
        changedValues['application']['stream'] = customToolValue;
      }
    }


    const payload = addExtrasFieldsToObject(changedValues, {
      applicationId,
      applicantId,
      parentId: applicantId,
    });


    if(payload?.addresses) {
      payload.addresses = payload.addresses.map((address, index) => {
        if (index === 0) {
          return { ...address, addressType: "Home" };
        } else if (index === 1) {
          return { ...address, addressType: "Current" };
        } else {
          return address;
        }
      });


      if (applicationData?.addresses?.length > 1) {
        if(payload?.addresses[0]?.isPermanentAddressSame == "true") {
          deleteRecordData(`type=addresses&recordIds=${applicationData?.addresses[1]?.recordId}`)
        }
      }
    }


    if(payload?.applicantRelations) {
      payload.applicantRelations = payload.applicantRelations.map((relation, index) => {
        const annualIncome = relation.annualIncome === null || relation.annualIncome === "" ? 0 : relation.annualIncome;
        relation.accountId = "0015g00000ED99sAAD";
        const updatedRelation = { ...relation, annualIncome };
        return updatedRelation;
      });
    }


    if(payload.applicant?.guardian == "No") {
      if(applicationData?.applicantRelations?.length > 0) {
        deleteRecordData(`type=applicantRelations&recordIds=${applicationData?.applicantRelations[2]?.recordId}`)
      }
    }
     


    // For Program in first step only
    if (payload.application?.appliedProgram && payload.application?.programId && activeStep === 0) {
      // For fetching programplanID
      const getId = form?.programs?.find((items) => {
        return items?.programId === payload.application?.programId;
      });
      const isAlreadyApplied = applicationData?.applicationPrograms;
      payload['applicationPrograms'] =
        isAlreadyApplied.length === 0
          ? [
              {
                Program_Plan__c: getId?.programPlanId,
              },
            ]
          : [{ ...isAlreadyApplied[0], Program_Plan__c: getId?.programPlanId }];
    }


    // SetLoader
    dispatchAppContext({ type: 'udpateLoading', value: true });
    // update currentStep
    const mainPayload = {
      applicationId,
      ...payload,
      ...applicationAddCurrentStep(payload.application, applicationData, activeStep, !isLastStep),
    };
    createUpdateApplication(mainPayload)
      .then((res) => {
        dispatchAppContext({ type: 'udpateLoading', value: false });
        // on success update context data and active step
        if (res?.success) {
          // update context
          let formattedData = { ...res.data };
          const getProgramId = form?.programs?.find((items) => {
            return items?.programPlanName === formattedData['application'].appliedProgram;
          });
          formattedData['application'].appliedProgram = getProgramId ? getProgramId?.departmentId : formattedData['application']?.appliedProgram ? formattedData['application']?.appliedProgram : null;
          applicationDispatch({
            type: 'update',
            payload: { applicationData: formattedData },
          });
          applicationDispatch({ type: 'nextStep' });
        }
      })
      .catch((error) => {
        dispatchAppContext({ type: 'udpateLoading', value: false });
        const errorMessage = error && error?.response?.data ? (Array.isArray(error?.response?.data?.errorMessages) ? error?.response?.data?.errorMessages[0]?.errorMessage : error?.response?.data?.errorMessage) : 'Something went wrong';
        enqueueSnackbar(errorMessage, {
          variant: 'error',
        });
      });
    };

  // based on stepType return components

  const getStepContent = () => {
    switch (step?.stepType) {
      case 'payment':
        return <PaymentStep handlePay={handlePay} applicationState={applicationState} applicationDispatch={applicationDispatch} />;
      case 'documentUpload':
        return <DocumentUpload applicationState={applicationState} applicationDispatch={applicationDispatch} />;
      case 'summary':
        return <SummaryStep saveForm={handleNext} applicationState={applicationState} applicationDispatch={applicationDispatch} />;
      case 'declaration':
        return <DeclarationStep applicationState={applicationState} applicationDispatch={applicationDispatch} />;
      default:
        return <FormStep step={step} ref={formRef} />;
    }
  };

  return (
    <>
      {loader && <KenLoader />}
      <Box component={'div'} marginTop={'30px'}>
        <form ref={formRef} onSubmit={methods.handleSubmit(onSubmit)} style={{ marginBottom: 120 }}>
          <FormProvider {...methods}>{getStepContent()}</FormProvider>
        </form>
        <KenStepperFooter isSave={applicationState?.steps[activeStep]?.stepId !== 'payment' && activeStep !== 0} nextLabel={applicationState?.steps[activeStep]?.stepId === 'payment' && applicationData?.application?.applicationStatus === 'Incomplete' ? 'Pay' : null} disablePrev={applicationState.declaration || applicationState?.applicationData?.application?.applicationStatus === 'Fee Paid'} disableNext={applicationState.summaryEdit !== ''} applicationStatus={applicationState?.applicationData?.application?.applicationStatus} disableSave={isLastStep} onNext={handleNext} onPrev={handlePrev} onSave={handleSave} activeStep={activeStep} totalSteps={totalSteps} />
      </Box>
    </>
  );
}

const DeclarationStep = (props) => {
  const { applicationState } = props;

  return (
    <Box sx={{ margin: '0 auto' }}>
      <Declaration formJson={applicationState.steps} data={applicationState.applicationData} applicationState={applicationState} />
    </Box>
  );
};

const PaymentStep = (props) => {
  const classes = useStyles();
  const { applicationState } = props;
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));

  return (
    <Paper elevation={0} style={{ maxWidth: isMobileScreen ? '90vw' : '70vw', margin: '0px auto' }}>
      <Box
        component={'div'}
        style={{
          display: 'flex',
          marginTop: '100px',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: isMobileScreen ? 'flex-start' : 'center',
        }}
      >
        <Box component={'div'} sx={{display: "flex", alignItems: "center", gap: "20px"}}>
          <img src={`https://flameprod.blob.core.windows.net/data/LOGO_VVI%20_with%20name.png`} alt="" style={{ width: 'auto', objectFit: "contain", height: '48px' }} />
          <Box component={"div"}>
          <Typography className={classes.Heading} align="left">
            Application for VAGDEVI VILAS INSTITUTIONS
          </Typography>
          <Typography className={classes.SubHeading2} style={{ marginTop: '12px' }} align="left">
            Dear {`${applicationState?.applicationData?.applicant?.firstName} ${applicationState?.applicationData?.applicant?.lastName}`} ,
            <br /> Your {` ${applicationState.applicationData.application.programName}`}  application will be finalized upon successful fee payment.
          </Typography>
          </Box>
        </Box>
        <Box component={'div'}>
          <Typography sx={{ marginBottom: '12px', marginTop: '9px' }} className={classes.SubHeading} align={isMobileScreen ? 'left' : 'right'}>
            Application Fee
          </Typography>
          <Typography
            align={isMobileScreen ? 'left' : 'right'}
            sx={{
              fontStyle: 'normal',
              fontWeight: '600',
              fontSize: '16px',
              color: '#505F79',
            }}
          >
            {applicationState?.feeDetails?.amount}
          </Typography>
        </Box>
      </Box>
      <Divider style={{ marginTop: '60px' }} />
    </Paper>
  );
};

const SummaryStep = (props) => {
  const { applicationState, applicationDispatch, saveForm } = props;
  const applicationStatus = applicationState.applicationSubmitted;

  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <>
      {/* Summary */}
      {!applicationStatus ? (
        <>
          <Box sx={{ width: '80vw', margin: '0 auto' }}>
            <KenSummaryStep saveForm={saveForm} formJson={applicationState.steps} data={applicationState.applicationData} applicationState={applicationState} />
          </Box>
        </>
      ) : (
        <Box margin="auto" height="90%" p={2} display="flex" justifyContent="center" alignContent="center" flexDirection="column">
          <ThankYouPage
            wrapperClassName={classes.thankYouContainer}
            titleClass={classes.title}
            subTitleClass={classes.subTitle}
            title="Thank you for your Application"
            redirection={false}
            description={
              <Typography>
                You have successfully Applied for
                {` ${applicationState?.applicationData?.application?.programName}`}
                <div style={{ fontSize: 14 }}>
                  Click here to redirect to{' '}
                  <span
                    className={classes.link}
                    onClick={() => {
                      applicationDispatch({ type: 'showHeader' });
                      navigate('/home');
                    }}
                  >
                    Homepage
                  </span>
                </div>
              </Typography>
            }
          />
        </Box>
      )}
    </>
  );
};
